import { isNil, isEmpty } from 'lodash';
import * as moment from 'moment';
// import 'url-search-params-polyfill';

export function isNullOrEmpty(obj) {
  return isNil(obj) || isEmpty(obj);
}

export function formatDate(date) {
  return moment(date).format('MM-DD-YYYY');
}
export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function twoDigiNumberWithCommas(x) {
  const num = (Math.round(x * 100) / 100).toFixed(2);
  return numberWithCommas(num.toString().split('.')[0])+'.'+num.toString().split('.')[1];
}

function parseLiffState(liffState, name) {
  console.log('parseLiffState liffState : ', liffState);
  const queryArray = liffState.split('?');
  let query = '?';
  if (queryArray.length > 1) {
    query = `?${queryArray[1]}`
  }
  console.log('parseLiffState query : ', query);
  const liffStateQuery = new URLSearchParams(query);
  console.log('parseLiffState return : ', liffStateQuery.get(name));
  return liffStateQuery.get(name);
}

export function getParam(name) {
  const queryString = decodeURIComponent(window.location.search);
  console.log('queryString : ', queryString);
  const query = new URLSearchParams(queryString);
  console.log(`${name} from query : `, query.get(name));
  return query.get(name) || parseLiffState(query.get('liff.state') || '', name) || queryString.replace(`?${name}=`, '');
}
